// extracted by mini-css-extract-plugin
module.exports = {"container":"cancel-subscription_container__2OCeh","unsubscribe":"cancel-subscription_unsubscribe__GRdjb"};